import { IArrangeTextTask, IArrangeTextTaskSession } from 'common/modules/ReactShared';
import React from 'react';
import { BaseCheckTaskBody, CheckNavFooter, SCheckTaskWrapper } from '../../components';
import { isLessonCompleted } from '../../helpers';
import { ICheckTaskProps } from '../types';
import { ArrangeTextItems, SDescription, SItem } from './components';
import { useArrangeTextTask } from './hooks';

type tArrangeTextTaskProps = ICheckTaskProps<IArrangeTextTask, IArrangeTextTaskSession>;

const CheckArrangeTextTask: React.FC<tArrangeTextTaskProps> = ({
  task,
  isCompleting,
  taskSession,
  onNext,
  previousTaskId
}) => {
  const { taskItems, handleDragEnd, handleNext, handleSkip } = useArrangeTextTask(
    task,
    onNext,
    taskSession
  );

  return (
    <>
      <SCheckTaskWrapper>
        <BaseCheckTaskBody task={task}>
          {taskItems.map((item, index) => (
            <SItem key={item.id}>
              <SDescription>{item.description}</SDescription>
              <ArrangeTextItems
                itemIndex={index}
                onDragEnd={handleDragEnd}
                options={item.options}
              />
            </SItem>
          ))}
        </BaseCheckTaskBody>
      </SCheckTaskWrapper>
      <CheckNavFooter
        isCompleting={isCompleting}
        onNext={handleNext}
        onSkip={handleSkip}
        isLessonCompleted={isLessonCompleted(taskSession)}
        previousTaskId={previousTaskId}
      />
    </>
  );
};

export default CheckArrangeTextTask;
